"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _TextFile = _interopRequireDefault(require("Icons/TextFile"));
var _Picture = _interopRequireDefault(require("Icons/Picture"));
var _PDFFile = _interopRequireDefault(require("Icons/PDFFile"));
var _RenderEditorText = _interopRequireDefault(require("../TextEditor/RenderEditorText"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Message = props => {
  var _files$;
  const {
    message,
    message_date,
    sent_by,
    files
  } = props.message;
  const formatedDate = (0, _moment.default)(message_date).format('Do MMMM [à] HH:mm');
  const [messageClass, setMessageClass] = (0, _react.useState)('message pratician-message');
  const fileType = files === null || files === void 0 ? void 0 : (_files$ = files[0]) === null || _files$ === void 0 ? void 0 : _files$.type;
  const Icon = fileType === "application" ? _TextFile.default : fileType === "pdf" ? _PDFFile.default : fileType === "image" ? _Picture.default : _TextFile.default;
  (0, _react.useEffect)(() => {
    if (sent_by === "deltex") {
      setMessageClass('message');
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: messageClass
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "message__info"
  }, "Le ", formatedDate), /*#__PURE__*/_react.default.createElement("div", {
    className: "message__message"
  }, /*#__PURE__*/_react.default.createElement(_RenderEditorText.default, {
    str: message
  })), files.length > 0 ? files.map(file => /*#__PURE__*/_react.default.createElement("div", {
    key: file.id,
    className: "message__file"
  }, /*#__PURE__*/_react.default.createElement("p", null, "fichier envoy\xE9 : ", file.title || file.filename), /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: file.url,
    className: "message__file_download"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: "c-file-thumbnail__icon"
  }), " "), " (", file.size_MB, "Mo)")) : undefined);
};
var _default = exports.default = Message;
